export default "__VITE_ASSET__Bhh3BY12__"